module.exports = __webpack_public_path__ + "img/1512974049.c467e636.jpg";